<template>
  <div class="forgetPassword">
    <div class="personal_loginRegister comWidth">
      <div class="form">
        <div class="left_box fl" style="margin-left: 0;border-right: 0;">
          <div class="register_box">
            <!--内地用户-->
            <ul class="z_reg" >
              <li>
                <label>帳號</label>
                <input type="text" v-model="users" placeholder="手機或郵箱">
              </li>
              <li class="dongtai" >
                <label class="w_116">驗證碼</label>
                <input v-model="captchaOne" class="telCo" type="text" placeholder="不區分大小寫">
                <a class="jiaZai">
                  <img :src="imgUrl"
                       alt="驗證碼"
                       v-if="ifImg"
                       width="100%"
                       id="imgcode"
                       @click="codeTab_1"/>
                  <span class="sIonUp" v-if="ifLod">
                        <i class="el-icon-loading" ></i>
                  </span>
                </a>
                <p id="z_dj" @click="codeTab_1">看不清楚？</p>
              </li>
              <li>
                <label>動態碼</label>
                <input v-model="verification_code" class="telCo"  type="text">

                <a class="sendCodeBox" @click="sendCodeOne()" >
                  <b class="to_havecode" ref="toHavecodeOne" v-if="toHavecodeOne">點擊獲取</b>
                  <b class="Codecountdown" v-if="codecountdownOne">
                    <span ref="num_1">60</span>s获取
                  </b>
                </a>
              </li>
              <li>
                <label>密碼</label>
                <input class="tbl-txt" @keyup="intensityJudge_1" v-model="password" type="password"  placeholder="6-12位数字加字母">
              </li>
              <li>
                <label>密碼強度 </label>
                <div id="level" ref="levelOne" class="qiangdu_box pw-strength">
                  <div class="pw-bar"></div>
                  <div class="pw-bar-on"></div>
                  <div class="pw-txt"></div>
                </div>
              </li>
              <li>
                <label>確認密碼 </label>
                <input v-model="password_confirmation" type="password" placeholder="請你確認密碼">
              </li>
              <button class="register_btn" type="button" @click="open1">修改</button>
            </ul>
          </div>
        </div>
      </div>

      <div class="right_box fr">
        <h5>登錄帳戶</h5>
        <p>
          1分鐘創建帳戶並完善個人信息，即可享受：<br>
          <i></i>安全快捷支付訂單<br>
          <i></i>隨時跟蹤訂單狀態<br>
          <i></i>即時享受积分打折優惠及新品發布信息
        </p>
        <router-link :to="{name:'SignIn'}" tag="a">已有帳戶？立即去登錄吧！</router-link>

      </div>
    </div>

    <!--导航-->
    <Nav :titles="titles" :titleChild="titleChild" :navState="navState" :tipsState="tipsState"/>
  </div>
</template>

<script>
  import Nav from '@/components/Nav'
  //api
  import { verificationReset, forgetPass } from '@/api/signIn';
  import {getCaptcha} from '@/api/getCode';
  //common.js
  import { intensityJudge } from '@/utils/common';
  //md5
  import md5 from 'js-md5'
  export default {
    name: 'ForgetPassword',
    components:{
      Nav
    },
    data () {
      return {
        //手机验证
        telRg:/^1[3,5,8,9,7]\d{9}$/,
        //邮箱验证
        emailRg: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
        padReg: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/, // 密码
        /*导航*/
        tipsState:true,
        navState:false,
        titles: '忘記密碼',
        titleChild:[],
        /*点击获取验证码*/
        toHavecodeOne:true,
        codecountdownOne:false,
        /*手机验证码或者邮箱验证码*/
        verification_key:'',
        coTE:'',
        /*内地用户*/
        users:'',
        password:'',
        password_confirmation:'',
        captchaOne:'',
        verification_code:'',

        /*token*/
        access_token:'',
        token_type:'',

        isClick:true,
        /*Captcha*/
        imgUrl:'',
        captcha_key:'',
        captcha_code:'',

        // 是否显示加载提示
        ifImg:true,
        ifLod:false,


      }
    },
    methods:{
      /*密码强弱判断*/
      intensityJudge_1(){
        var levelOne = this.$refs.levelOne;
        var password = this.password;
        intensityJudge(levelOne,password)
      },

      /*点击获取手机验证码*/
      sendCodeOne(){
        if(!(this.telRg.test(this.users))){
          this.$message.error('請輸入正確的手機號');
        }else if(md5((this.captchaOne).trim()) != this.captcha_code ){
          this.$message.error('請輸入正確的動態驗證碼');
          this.captchaCode();
        } else {
          var users = this.users;
          var usersObj = {
            username:users,
            captcha_key:this.captcha_key,
            captcha_code:this.captchaOne,
            action:"reset_pwd"};
          if(this.isClick){
            this.isClick = false;
            //发送验证
            verificationReset(usersObj)
              .then(res => {
                this.verification_key = res.data.key;
                this.coTE = res.data.code;
                this.toHavecodeOne = false;
                this.codecountdownOne = true;
                var time_s = 60;
                var j = setInterval(() => {
                  time_s --;
                  this.$refs.num_1.textContent = time_s;
                  if(time_s <= 0){
                    this.isClick = true;
                    this.toHavecodeOne = true;
                    this.codecountdownOne = false;
                    window.clearInterval(j);
                  }
                },1000);
              })
          }
        }
      },

      /*忘记密码验证*/
      open1() {
          var RegPara = {
              //手机号或者邮箱
            usersE :(this.users).trim(),
              //第一次输入的密码
              password :(this.password).trim(),
              //确认密码
              confirmPassword:(this.password_confirmation).trim(),
              //图形动态验证码
              captcha: (this.captchaOne).trim(),
              //手机动态验证码 或者邮箱动态验证码
              code:(this.verification_code).trim()
          };

            //错误提示
          var tips = {
            usersE:'請輸入正確的手機號或郵箱',
              paS:'6-12位數字加字母',
              paQn:'兩次輸入的密碼不一致，請重新輸入',
              coK:'請輸入正確的動態驗證碼',
            usersECode:'請輸入正確的手機驗證碼或郵箱驗證碼',
          };

          this.verification(this.telRg,this.emailRg,RegPara ,tips,this.captcha_code,this.coTE);
      },

      /*忘记密码验证*/
      verification( Reg ,emailRg,RegPara,tips,captcha_code,coTE){
        if( !(Reg.test(RegPara.usersE)) && !(emailRg.test(RegPara.usersE))){
          this.$message.error(tips.usersE);
        }else if(md5((RegPara.captcha).trim()) != captcha_code){
          this.$message.error(tips.coK);
          this.captchaCode();
        }else if(md5(RegPara.code) != coTE){
          this.$message.error(tips.usersECode);
        } else if(!this.padReg.test(RegPara.password)){
          this.$message.error(tips.paS);
        }else if(RegPara.confirmPassword == '' || RegPara.password != RegPara.confirmPassword){
          this.$message.error(tips.paQn);
        }else {
            //修改
          var userObjOne = {
            password:this.password,
            password_confirmation:this.password_confirmation,
            verification_key:this.verification_key,
            verification_code:this.verification_code,
          };
          forgetPass(userObjOne).then(res =>{
              this.access_token = res.data;
            this.$message.success('修改成功');
            this.$router.push({
              name:'SignIn'
            })
          })
        }
      },

      /*图形验证码切换*/
      codeTab_1(){
        this.ifImg = false
        this.ifLod = true
        this.captchaCode();
        setTimeout(() => {
          this.ifImg = true
          this.ifLod = false
        }, 1000);
      },

      /*获取动态验证码*/
      captchaCode(){
        getCaptcha().then(res =>{
          this.imgUrl = res.data.captcha_image_content
          this.captcha_key = res.data.captcha_key
          this.captcha_code = res.data.code
        }).catch(err =>{
          this.$message.warning('操作頻繁，請稍後再試')
        })
      }
    },
    created(){
        this.captchaCode();
        window.scrollTo(0,0)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import "../../css/signUp.less";
  .forgetPassword .z_reg label.w_116{
    width: 116px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/ForgetPassword.vue